import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import ChargeRequestSelect from "../Routes/ChargeManager/ChargeRequestSelect/index";
import ChargeRequestList from "../Routes/ChargeManager/ChargeRequest/List/index";

// 충전담당(ChargeRequestConfig.manager 로 지정된 계정) 전용 화면.
// 담당으로 지정된 충전내역 설정과 그에 속한 충전내역만 다룬다.
const ChargeManagerRoutes = ({
  userData,
  history,
  location,
  match,
  isModal,
  previousLocation,
}) => (
  <Switch location={isModal ? previousLocation : location}>
    {/* 담당 충전내역 설정 목록 (랜딩) */}
    <Route exact path="/chargeManager/configs">
      <ChargeRequestSelect userData={userData} />
    </Route>

    {/* 담당 충전내역 */}
    <Route
      exact
      path="/chargeManager/configs/:chargeRequestConfig/chargeRequests"
      component={ChargeRequestList}
    />

    <Redirect from="*" to="/chargeManager/configs" />
  </Switch>
);

export default ChargeManagerRoutes;
